import React, { useState,useEffect } from "react";
import { Link, useNavigate,useParams } from 'react-router-dom'
import axios from "axios";
import moment from 'moment'
import { facultyposlists } from '../../../apis/urls'
import { degreeurl,mailsend } from '../../../apis/urls'
import { schoolFacultyurl } from '../../../apis/urls'
import { Multiselect } from "multiselect-react-dropdown";
import { decode } from "html-entities";
const EditFaculty = () =>{

    const { id, facid } = useParams();
    const username = localStorage.getItem('username')
    useEffect(() => {
        editlisting();
        //DegreeListing();
        PositionListing();
    },[]
    );

    const [fresult,setFresult] = useState([]);
    //const [dresult,setDresult] = useState([]);
    const [res,setRes] = useState([]);
    const [positions, setPositions] = useState([])
    
    const [title,setTitle] = useState('');
    const [fname,setFname] = useState('');
    const [mname,setMname] = useState('');
    const [lname,setLame] = useState('');
    const [appointed_date,setAppointed_date] = useState('');
    const [email,setEmail] = useState('');
    const [phone,setPhone] = useState('');
    const [cellphone,setCellphone] = useState('');
    const [fax,setFax] = useState('');
    const [positionid,setPositionid] = useState([]);
    //const [degreeid,setDegreeid] = useState('');
    const [status,setStatus] = useState('');
    const [postns,setPosi] = useState([]);

    let facArray = []

    const handleSelect = (id) => {
        // setSchool_id(id)
            id?.map((item,index) => {
                facArray.push(item.id)
            }
            
            )
            setPositionid(facArray)
            console.log(facArray)
            return facArray;
    };
    
    
    const handleRemove = (id) => {
        let arr= []
        console.log(id)
        id?.map((item,index) => {
            arr.push(item.id)
        }
        )

        setPositionid(arr)
    };

    const PositionListing = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: facultyposlists+'?page='+0+'&size='+200,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setFresult(response.data.data.items);
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }



    const editlisting = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: schoolFacultyurl+'/'+id+'/'+facid,

            timeout: 1000000,

            headers: {'authorization': token}

            });
            
            instance.get('').then((response) =>{
            
            setRes(response.data.data);
            //console.log("name",res)
            setTitle(response.data.data.title);
            setFname(response.data.data.first_name);
            setMname(response.data.data.middle_name);
            setLame(response.data.data.last_name);
            setAppointed_date(response.data.data.appointed_date);
            setEmail(response.data.data.email);
            setPhone(response.data.data.phone);
            setCellphone(response.data.data.cell_phone);
            setFax(response.data.data.fax);
            //setDegreeid(response.data.data.degree_id);
            setStatus(response.data.data.status);
            setPosi(response.data.data.faculty_multiple_positions)
            let arr = []
            let ids = []
            response.data.data.faculty_multiple_positions.map((item) => {
            //  item.faculty_position
                let data = {
                    id: item.faculty_position.id,
                    name: item.faculty_position.name
                }
                arr = [...arr, data]
                ids = [...ids, item.faculty_position.id]
            })
            setPositionid(ids);
            setPositions(arr)
            }).catch((error) =>{
            
            console.log('error',error.message)
            

            });
    }

    const onEditForm = (id,facid) => {

        let token = "Bearer "+localStorage.getItem('token');

        
        const data = {
            title :title,
            first_name :fname,
            middle_name:mname,
            last_name:lname,
            appointed_date:moment(appointed_date).format('MM-DD-YYYY'),
            email:email,
            phone:phone,
            cell_phone :cellphone,
            fax :fax,
            school_id:id,
            position_id:positionid,
            //degree_id:degreeid,
            status :status
        }
        
        const instance = axios.create({

            baseURL: schoolFacultyurl+'/'+id+'/'+facid,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.put('',data).then((response) =>{
            
            navigate("/school_list/faculty/"+id)

          }).catch((error) =>{
            
            console.log('error',error.message)

           
            

          });
    }
   
    let navigate = useNavigate();
    const RoutToList = () =>{
        let path = 'newPath'; 
        navigate("/school_list/faculty/"+id)
    }
    
    return(
        <div className="wrapper">
            <aside className="right-side ">
            <div className="content-area">	
            <div className="page-title-wrpr">
                <div className="page-title-left-column"> 
                    <h2 className="page-title">Edit Admin/Staff</h2>
                </div>
                <div className="page-rightside-action-column">               
                </div>  
            </div>
        
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li className="breadcrumb-item"><Link to={"/school_list/faculty/"+id}>Admin/Staff</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Edit Admin/Staff</li>
              </ol>
            </nav>
         
            <div className="form-wrpr">
                <div className="card formcard small">
                    <div className="card-body">
                        <div className="form-group">
                            <label className="degreehead">Title <span style={{color: "red"}}>*</span></label>
                            {/* <input type="text" className="form-control bg-dark dark-theme showtext" defaultValue={res.title} onChange={e => {setTitle(e.target.value)}} placeholder="Enter Title" id="name"></input> */}
                            <select 

                                defaultValue={title}
                            
                                className="form-control bg-dark dark-theme showtext" 
                                
                                onChange={e => {setTitle(e.target.value)}} 
                                
                                id="status-selector"
                                
                            >
                                
                                {/* <option value="0">Select Title</option> */}

                                <option value="Dr." selected = {res.title === "Dr." }>Dr.</option>
                                <option value="Mr." selected = {res.title === "Mr." }>Mr.</option>
                                <option value="Mrs." selected = {res.title === "Mrs." }>Mrs.</option>
                                <option value="Ms." selected = {res.title === "Ms." }>Ms.</option>
                                <option value="Miss." selected = {res.title === "Miss." }>Miss.</option>
                                     
                                {/* <option defaultValue={title} selected = {res.title === title}>{title}</option> */}

                            </select>
                        </div>
                        <div className="form-group">
                            <label className="degreehead">First Name <span style={{color: "red"}}>*</span></label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" defaultValue={decode(res.first_name)} onChange={e => {setFname(e.target.value)}} placeholder="Enter First Name" id="name"></input>
                        </div>
                        <div className="form-group">
                            <label className="degreehead">Middle Name</label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" defaultValue={decode(res.middle_name)} onChange={e => {setMname(e.target.value)}} placeholder="Enter Middle Name" id="name"></input>
                        </div>
                        <div className="form-group">
                            <label className="degreehead">Last Name <span style={{color: "red"}}>*</span></label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" defaultValue={decode(res.last_name)} onChange={e => {setLame(e.target.value)}} placeholder="Enter Last Name" id="name"></input>
                        </div>
                        <div className="form-group">
                            <label className="degreehead">Appointed Date <span style={{color: "red"}}>*</span></label>
                            <input type="date" className="form-control bg-dark dark-theme showtext" defaultValue={res.appointed_date} onChange={e => {setAppointed_date(e.target.value)}} id="name"></input>
                        </div>
                        <div className="form-group">
                            <label className="degreehead">Email <span style={{color: "red"}}>*</span></label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" defaultValue={res.email} onChange={e => {setEmail(e.target.value)}} placeholder="Enter The Email" id="name"></input>
                        </div>
                        <div className="form-group">
                            <label className="degreehead">Phone <span style={{color: "red"}}>*</span></label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" defaultValue={res.phone} onChange={e => {setPhone(e.target.value)}} placeholder="Enter The Phone (XXX-XXX-XXXX)" id="name"></input>
                        </div>

                        <div className="form-group">
                            <label className="degreehead">Cell Phone</label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" defaultValue={res.cell_phone} onChange={e => {setCellphone(e.target.value)}} placeholder="Enter The Cell Phone (XXX-XXX-XXXX)" id="name"></input>
                        </div>

                        {/* <div className="form-group">
                            <label className="degreehead">Fax</label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" defaultValue={res.fax} onChange={e => {setFax(e.target.value)}} placeholder="Enter The Fax" id="name"></input>
                        </div> */}

                        <div className="form-group">
                            <label className="degreehead">Positions <span style={{color: "red"}}>*</span></label>

                            <Multiselect
                                    options={fresult}
                                    defaultValue={facArray}
                                    selectedValues={positions}
                                    onSelect={handleSelect}
                                    onRemove={handleRemove} 
                                    displayValue="name" />

                                    {
                                        positionid?.length === 0 && <span style={{color: "red"}}>Please Select Position</span>
                                        
                                    }

                            {/* <select className="form-control bg-dark dark-theme showtext" onChange={e => {setPositionid(e.target.value)}} id="status-selector">
                                <option value="0">Select Job Position</option>
                                {
                                    fresult?.map((item,index)=>(
                                        
                                        <option key={index} value={item.id} selected = {item.id === res.position_id }>{item.name}</option>
                                        
                                    )
                                    
                                    )
                                }
                             
                            </select> */}
                        </div>
                        {/* <div className="form-group">
                            <label className="degreehead">Degree <span style={{color: "red"}}>*</span></label>
                            <select className="form-control bg-dark dark-theme showtext" onChange={e => {setDegreeid(e.target.value)}} id="status-selector">
                                <option value="0">Select Degree</option>
                                {
                                    dresult?.map((item,index)=>(
                                        
                                        <option key={index} value={item.id} selected = {item.id === res.degree_id  }>{item.name}</option>
                                        
                                    )
                                    
                                    )
                                }
                             
                            </select>
                        </div> */}

                        <div className="form-group">
                            <label className="degreehead">Status <span style={{color: "red"}}>*</span></label>
                            <select className="form-control bg-dark dark-theme showtext" onChange={e => {setStatus(e.target.value)}} id="status-selector">
                                <option value="ACTIVE">Select Status</option>
                              <option value="ACTIVE" selected = {res.status === 'ACTIVE'}>ACTIVE</option>
                              <option value="INACTIVE" selected = {res.status === 'INACTIVE'}>INACTIVE</option>
                              <option value="DELETED" selected = {res.status === 'DELETED'}>DELETED</option>
                            </select>                        
                        </div>
                        <h6 style={{color: "red"}}>* Required Fields</h6>
                        
                        
                        <div className="form-group text-right">
                        <button className="btn btn-danger btn-gisa" onClick={RoutToList} type="submit">Cancel</button>
                        <button onClick={()=>{ onEditForm(id,facid) }} className="btn btn-primary btn-gisa" type="button">Update</button>
                        </div>
                    </div>
                </div>
                
            </div>
            a
        </div>
            </aside>
        </div>
    )
}

export default EditFaculty;
